(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lance-25-rail"] && !Shopify.designMode) return;
  try {
    
class Lance25Rail extends HTMLElement {
  connectedCallback() {
    const show = (key) => {
      this.querySelectorAll('[data-l25-panel]').forEach((p) => { p.hidden = p.dataset.l25Panel !== key; });
      this.querySelectorAll('[data-l25-fam]').forEach((b) => b.classList.toggle('is-active', b.dataset.l25Fam === key));
    };
    this.querySelectorAll('[data-l25-fam]').forEach((b) => b.addEventListener('click', () => show(b.dataset.l25Fam)));
    this.querySelectorAll('[data-l25-jump]').forEach((b) => b.addEventListener('click', () => show(b.dataset.l25Jump)));
  }
}
customElements.define('lance-25-rail', Lance25Rail);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lance-audience"] && !Shopify.designMode) return;
  try {
    
class LanceAudience extends HTMLElement {
  connectedCallback() {
    this.PD = JSON.parse(this.querySelector('[data-aud-setdata]').textContent);
    // DC audDefs[aud].sets verbatim
    const SETS = {
      artists: {
        space: 'studio', color: '#FF3D9A', ink: '#FFFFFF',
        sets: [
          {name:'Artist Desk Set',why:'Layout, centered composition, and cut lines at the desk.',items:[['lance-french-curve',1],['straight-edge-with-slip-resistant-backing',1],['center-finding-rule',1]]},
          {name:'Large-Format Studio Set',why:'Long true lines and gripped edges for oversized work.',items:[['straight-edge-aluminum-rule',1],['straight-edge-with-slip-resistant-backing',1],['lance-hip-curve',1]]},
          {name:'Print & Book Arts Set',why:'Publication scales, centered folds, and inking edges that do not slide.',items:[['lance-agate-pica-ruler',1],['center-finding-rule',1],['straight-edge-with-slip-resistant-backing',1]]}
        ]},
      engineers: {
        space: 'lab', color: '#2038E8', ink: '#FFFFFF',
        sets: [
          {name:'Engineer Desk Set',why:'Inch + cm on one edge, fixed angles, and centers without arithmetic.',items:[['lance-straight-edge-e-metric-inch-centimeter',1],['template-triangle-ruler-30-60-90',1],['center-finding-rule',1]]},
          {name:'Technical Drawing Set',why:'The stainless edge, both drafting geometries, and the curve between them.',items:[['heavy-duty-drafting-stainless-steel-t-square',1],['template-triangle-ruler-30-60-90',1],['template-triangle-ruler-45-45-90',1],['lance-french-curve',1]]},
          {name:'Graduation & New-Hire Set',why:'A serious first instrument — desk-scale, durable, quietly symbolic.',items:[['lance-straight-edge-e-metric-inch-centimeter',1],['template-triangle-ruler-45-45-90',1]]}
        ]},
      makers: {
        space: 'shop', color: '#FF7A00', ink: '#131313',
        sets: [
          {name:'Cutting Table Set',why:'A gripped cutting edge, a heavy square to pull against, and one exact corner.',items:[['straight-edge-with-slip-resistant-backing',1],['heavy-duty-t-square',1],['aluminum-l-square',1]]},
          {name:'Pattern & Curve Set',why:'The patternmaking bench — long contours, tight transitions, cuffs, half-scale drafting.',items:[['lance-hip-curve',1],['lance-french-curve',1],['aluminum-cuff-rule',1],['lance-half-size-l-square',1]]},
          {name:'Long-Span Layout Set',why:'The long, true line plus direct centers for panels and spans.',items:[['straight-edge-aluminum-rule',1],['center-finding-rule',1]]}
        ]}
    };
    this.A = SETS[this.dataset.aud] || SETS.artists;
    this.mult = 1;
    this.render();
  }
  money(v) { return '$' + (v % 1 ? v.toFixed(2) : v.toFixed(0)); }
  render() {
    const A = this.A, m = this.mult;
    const chips = [{m:1,label:'One desk'},{m:4,label:`Shared ${A.space} ×4`},{m:12,label:'Whole program ×12'}];
    this.querySelector('[data-aud-scale]').innerHTML = chips.map((c) =>
      `<button data-mult="${c.m}" style="background:${m === c.m ? '#131313' : '#FFFFFF'};color:${m === c.m ? '#FBF8EF' : '#131313'};border:2px solid #131313;padding:9px 15px;font-family:'Archivo',sans-serif;font-weight:700;font-size:13.5px;cursor:pointer;">${c.label}</button>`).join(' ');
    this.querySelectorAll('[data-mult]').forEach((b) => b.addEventListener('click', () => { this.mult = Number(b.dataset.mult); this.render(); }));
    this.querySelector('[data-aud-scalenote]').textContent = m === 1 ? 'EVERY TOOL IS ALSO SOLD ON ITS OWN' : `QUANTITIES ×${m} — THE PRO DESK CONFIRMS VOLUME PRICING`;
    this.querySelector('[data-aud-sets]').innerHTML = A.sets.map((st) => {
      let tot = 0;
      const rows = st.items.map((it) => { const p = this.PD[it[0]]; if (!p) return '';
        tot += p.price * it[1] * m;
        return `<a href="${p.url}" style="display:flex;align-items:center;gap:10px;text-decoration:none;color:#131313;border:2px solid #E2DDCB;padding:7px 9px;background:#FBF8EF;">
          <img loading="lazy" decoding="async" src="${p.img}" alt="" style="width:46px;height:34px;object-fit:contain;flex:none;background:#FFFFFF;border:1px solid #E2DDCB;">
          <span style="flex:1;min-width:0;font-size:13px;font-weight:600;line-height:1.25;">${p.name}</span>
          <span style="font-family:'IBM Plex Mono',monospace;font-size:11px;color:#6B675C;flex:none;">×${it[1] * m} · ${this.money(p.price)}</span></a>`; }).join('');
      const est = this.money(Math.round(tot));
      return `<article style="background:#FFFFFF;border:3px solid #131313;display:flex;flex-direction:column;">
        <div style="padding:16px 16px 12px;border-bottom:3px solid #131313;background:${A.color};color:${A.ink};">
          <h3 style="font-family:'Bricolage Grotesque',sans-serif;font-weight:800;font-size:21px;line-height:1;margin:0;">${st.name}</h3>
          <p style="margin:6px 0 0;font-size:13px;line-height:1.45;">${st.why}</p>
        </div>
        <div style="padding:12px 14px;display:flex;flex-direction:column;gap:8px;flex:1;">${rows}</div>
        <div style="padding:12px 14px 14px;border-top:2px solid #131313;display:flex;align-items:center;justify-content:space-between;gap:10px;flex-wrap:wrap;">
          <span style="font-family:'Bricolage Grotesque',sans-serif;font-weight:800;font-size:19px;">${est}<span style="font-family:'IBM Plex Mono',monospace;font-size:9px;letter-spacing:.08em;color:#8F8B7E;font-weight:400;display:block;">ESTIMATE — NOT A LIVE QUOTE</span></span>
          <button data-lance-inquiry data-inq-title="Team pricing" data-inq-ctx="${st.name}||Estimated ${est}" data-inq-note="The PRO desk resolves exact configurations and a formal quote." style="background:transparent;color:#131313;border:2px solid #131313;padding:9px 13px;font-family:'Archivo',sans-serif;font-weight:700;font-size:12.5px;cursor:pointer;">Team pricing</button>
        </div></article>`;
    }).join('');
  }
}
customElements.define('lance-audience', LanceAudience);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lance-finder"] && !Shopify.designMode) return;
  try {
    
class LanceFinder extends HTMLElement {
  connectedCallback() {
    // DC tags() verbatim: t = jobs, s = shape, unit, rank, grip
    this.TAGS = {
      'aluminum-cuff-rule':{t:['garments'],s:'special',unit:'inch',rank:5,alt:'Its own width is the cuff-depth reference — mark identical cuffs without arithmetic.'},
      'aluminum-l-square':{t:['garments','drafting'],s:'angle',unit:'inch',rank:8,alt:'The full-scale two-leg square — a calibrated corner for the cutting table.'},
      'lance-half-size-l-square':{t:['garments','drafting'],s:'angle',unit:'inch',rank:6,alt:'Half-scale legs for reduced-scale pattern drafting.'},
      'black-anodized-e-metric-ruler-inch-centimeter':{t:['shop','cutting'],s:'straight',unit:'both',rank:7,alt:'Combined inch + cm engraving — orientation-independent.'},
      'black-anodized-left-right-top-edge-rule':{t:['shop'],s:'straight',unit:'inch',rank:6,alt:'The same rule, oriented for a different stance.'},
      'black-anodized-left-right-bottom-edge-rule':{t:['shop'],s:'straight',unit:'inch',rank:5,alt:'The same rule, oriented for a different stance.'},
      'black-anodized-right-left-top-edge-rule':{t:['shop'],s:'straight',unit:'inch',rank:5,alt:'The same rule, oriented for a different stance.'},
      'black-anodized-right-left-bottom-edge-rule':{t:['shop'],s:'straight',unit:'inch',rank:5,alt:'The same rule, oriented for a different stance.'},
      'black-metric-left-right-top-edge-rule':{t:['shop'],s:'straight',unit:'metric',rank:5,alt:'Metric engraving in the same orientation system.'},
      'black-metric-left-right-bottom-edge-rule':{t:['shop'],s:'straight',unit:'metric',rank:5,alt:'Metric engraving in the same orientation system.'},
      'black-metric-right-left-top-edge-rule':{t:['shop'],s:'straight',unit:'metric',rank:5,alt:'Metric engraving in the same orientation system.'},
      'black-metric-right-left-bottom-edge-rule':{t:['shop'],s:'straight',unit:'metric',rank:5,alt:'Metric engraving in the same orientation system.'},
      'center-finding-rule':{t:['layout','garments','shop'],s:'center',unit:'inch',rank:6,alt:'Zero sits in the middle — centers read directly, no arithmetic.'},
      'heavy-duty-drafting-stainless-steel-t-square':{t:['drafting','cutting'],s:'angle',unit:'inch',rank:7,alt:'A stainless blade for drafting edges that must not wear.'},
      'heavy-duty-t-square':{t:['drafting','cutting'],s:'angle',unit:'inch',rank:9,alt:'A heavier head for cutting-table duty.'},
      'standard-t-square':{t:['drafting','cutting'],s:'angle',unit:'inch',rank:8,alt:'The lighter, standard-duty T-square.'},
      'lance-agate-pica-ruler':{t:['print','layout'],s:'special',unit:'inch',rank:5,alt:'Agate and pica scales — publication lines are counted, not guessed.'},
      'lance-french-curve':{t:['garments','drafting'],s:'curve',unit:'inch',rank:8,alt:'Better for shorter, tighter curve transitions.'},
      'lance-hip-curve':{t:['garments'],s:'curve',unit:'inch',rank:8,alt:'Better for long garment contours.'},
      'lance-straight-edge-e-metric-inch-centimeter':{t:['cutting','drafting','shop'],s:'straight',unit:'both',rank:8,alt:'Carries inch and centimeter together on one tool.'},
      'lance-straight-edge-metric-centimeter':{t:['cutting','drafting','shop'],s:'straight',unit:'metric',rank:7,alt:'Metric-only calibration, 30–100 cm.'},
      'straight-edge-aluminum-rule':{t:['cutting','drafting','shop'],s:'straight',unit:'inch',rank:10,alt:'The plain inch straight edge — the widest length range, 6″ to 144″.'},
      'straight-edge-with-slip-resistant-backing':{t:['cutting','print'],s:'straight',unit:'inch',rank:9,grip:1,alt:'Better when the rule must not slide — cork backing grips the sheet for inking and cutting.'},
      'template-triangle-ruler-30-60-90':{t:['drafting'],s:'fixed',unit:'inch',rank:7,alt:'Better for drafting — fixed 30/60/90 working angles.'},
      'template-triangle-ruler-45-45-90':{t:['drafting'],s:'fixed',unit:'inch',rank:7,alt:'Better for drafting — fixed 45/45/90 working angles.'}
    };
    this.BLACK = Object.keys(this.TAGS).filter((h) => h.indexOf('black-') === 0);
    this.JOBS = [
      {id:'garments',label:'Marking & cutting garments',sub:'Patterns, hems, cuffs, contours',color:'#FF3D9A',ink:'#FFFFFF'},
      {id:'drafting',label:'Drafting & technical drawing',sub:'Lines, angles, and layouts on the board',color:'#B79CFF',ink:'#131313'},
      {id:'print',label:'Print & publication layout',sub:'Column inches, picas, paste-up',color:'#FFC400',ink:'#131313'},
      {id:'shop',label:'Machine-shop & bench work',sub:'Scribing and reading at the station',color:'#00E5A0',ink:'#131313'},
      {id:'cutting',label:'Cutting & inking against an edge',sub:'Blades and pens pulled along the rule',color:'#FF9E00',ink:'#131313'},
      {id:'layout',label:'Centering & layout',sub:'Finding middles, spacing, alignment',color:'#00C2FF',ink:'#131313'}
    ];
    this.SH = {straight:'A straight line',angle:'A right angle',fixed:'A fixed angle',curve:'A smooth curve',center:'Find the center',special:'A special job'};
    this.P = JSON.parse(this.querySelector('[data-f-products]').textContent);
    this.byH = {}; this.P.forEach((p) => { this.byH[p.handle] = p; });
    this.st = { job: null, shape: null, c: null, L: null };
    const qjob = new URLSearchParams(location.search).get('job');
    if (qjob && this.JOBS.some((j) => j.id === qjob)) this.st.job = qjob;
    this.render();
  }
  lensOf(p) { return p.variants.map((v) => (v.mm || 0) / 25.4).filter((x) => x > 0); }
  matches(job, shape) {
    return this.P.filter((p) => { const tg = this.TAGS[p.handle] || { t: [], s: '' };
      return (!job || tg.t.indexOf(job) > -1) && (!shape || tg.s === shape); });
  }
  render() {
    const s = this.st, T = this.TAGS;
    let cands = s.job && s.shape ? this.matches(s.job, s.shape) : [];
    cands.sort((a, b) => ((T[b.handle] || {}).rank || 0) - ((T[a.handle] || {}).rank || 0));
    const allBlack = cands.length > 0 && cands.every((p) => this.BLACK.indexOf(p.handle) > -1);
    let cType = null, cOpts = [];
    if (cands.length > 1 && !allBlack) {
      const units = []; cands.forEach((p) => { const u = (T[p.handle] || {}).unit; if (u && units.indexOf(u) < 0) units.push(u); });
      const maxLs = cands.map((p) => Math.max(...this.lensOf(p), 1));
      const spread = Math.max(...maxLs) / Math.min(...maxLs);
      const grips = cands.some((p) => (T[p.handle] || {}).grip);
      if (units.length > 1) { cType = 'unit';
        const uL = {inch:['Inch','Eighths and sixteenths'],metric:['Metric (cm)','Centimeters only'],both:['Inch + cm','Both systems on one tool']};
        cOpts = units.map((u) => ({ label: uL[u][0], sub: uL[u][1], v: 'u:' + u }));
      } else if (spread > 2.5) { cType = 'span';
        cOpts = [{v:'s:sm',label:'Fits in a tool bag',sub:'Work under 24″'},{v:'s:md',label:'Desk & table',sub:'Work 24″ to 60″'},{v:'s:lg',label:'Full workstation',sub:'Work beyond 60″'}];
      } else if (grips) { cType = 'grip';
        cOpts = [{v:'g:y',label:'Grips the sheet',sub:'Inking & cutting — the rule must not slide'},{v:'g:n',label:'Slides freely',sub:'Marking & measuring — move it fast'}];
      }
    }
    const needC = !!cType;
    let finl = cands.slice();
    if (s.c) {
      const kind = s.c.slice(0, 1), val = s.c.slice(2); let filt = [];
      if (kind === 'u') filt = finl.filter((p) => (T[p.handle] || {}).unit === val);
      else if (kind === 's') filt = finl.filter((p) => { const ls = this.lensOf(p); const mx = Math.max(...ls, 1), mn = Math.min(...ls, mx);
        if (val === 'sm') return mn <= 24; if (val === 'md') return mx >= 24 && mn <= 60; return mx >= 60; });
      else if (kind === 'g') filt = finl.filter((p) => (val === 'y' ? (T[p.handle] || {}).grip : !(T[p.handle] || {}).grip));
      if (filt.length) finl = filt;
    }
    const resolved = cands.length > 0 && !allBlack && (!needC || !!s.c);
    const stage = !s.job ? 0 : (!s.shape ? 1 : (allBlack ? 3 : (needC && !s.c ? 2 : 3)));
    const titles = ['What are you making?', 'What line do you need?', 'One more thing —', 'Your exact match.'];
    const cTitles = {unit:'Which unit system do you read?',span:'How long is the work?',grip:'Does the edge need to grip?'};
    this.querySelector('[data-f-title]').textContent = stage === 2 ? (cTitles[cType] || titles[2]) : titles[stage];
    this.querySelector('[data-f-step]').textContent = stage >= 3 ? 'RESOLVED' : 'QUESTION ' + (stage + 1) + ' OF 3';
    // candidate field
    const liveSet = s.job ? (s.shape ? finl : this.matches(s.job, null)) : this.P;
    const FAMC = {'straight-edge':'#2038E8','t-square':'#FF4B00','l-square':'#C6EF1F','curve':'#FF3D9A','triangle':'#6E30F2','special':'#FFC400','black':'#131313'};
    const famColor = (h) => h.indexOf('black-') === 0 ? FAMC.black : (h.indexOf('t-square') > -1 ? FAMC['t-square'] : (h.indexOf('l-square') > -1 ? FAMC['l-square'] : (h.indexOf('curve') > -1 ? FAMC.curve : (h.indexOf('triangle') > -1 ? FAMC.triangle : ((T[h] || {}).s === 'special' || (T[h] || {}).s === 'center' ? FAMC.special : FAMC['straight-edge'])))));
    const rankedLive = liveSet.slice().sort((a, b) => ((T[b.handle] || {}).rank || 0) - ((T[a.handle] || {}).rank || 0));
    const shown = rankedLive.slice(0, 8);
    const remaining = rankedLive.length - shown.length;
    this.querySelector('[data-f-field]').innerHTML = shown.map((p) =>
      `<span class="lf2__candidate" style="--lf2-family:${famColor(p.handle)};"><img loading="lazy" decoding="async" src="${p.img}" width="300" height="300" alt=""><span>${p.name}</span></span>`
    ).join('') + (remaining > 0 ? `<p class="lf2__candidate-more">+ ${remaining} more ${remaining === 1 ? 'match' : 'matches'} — your next answer narrows the list.</p>` : '');
    this.querySelector('[data-f-count]').textContent = liveSet.length;
    // crumbs
    const crumbs = [];
    if (s.job) crumbs.push({ label: (this.JOBS.find((j) => j.id === s.job) || {}).label, k: 'job' });
    if (s.shape) crumbs.push({ label: this.SH[s.shape], k: 'shape' });
    if (s.c && crumbs.length === 2) crumbs.push({ label: 'Constraint', k: 'c' });
    const cw = this.querySelector('[data-f-crumbs]');
    cw.innerHTML = crumbs.map((c) => `<button class="lf2__crumb" data-crumb="${c.k}">${c.label} ✕</button>`).join('');
    cw.querySelectorAll('[data-crumb]').forEach((b) => b.addEventListener('click', () => {
      const k = b.dataset.crumb;
      if (k === 'job') Object.assign(this.st, { job: null, shape: null, c: null });
      if (k === 'shape') Object.assign(this.st, { shape: null, c: null });
      if (k === 'c') this.st.c = null;
      this.st.L = null; this.render();
    }));
    // stage body
    const stageEl = this.querySelector('[data-f-stage]');
    if (stage === 0) {
      stageEl.innerHTML = '<div style="display:grid;grid-template-columns:repeat(auto-fit,minmax(min(270px,100%),1fr));gap:10px;">' + this.JOBS.map((j) =>
        `<button class="lf2__job" data-job="${j.id}" style="--jc:${j.color};--jink:${j.ink};"><span aria-hidden="true" style="width:20px;height:20px;background:${j.color};border:2px solid #131313;flex:none;display:block;"></span><span><span style="display:block;font-weight:700;font-size:15px;">${j.label}</span><span style="display:block;font-size:12.5px;opacity:.75;margin-top:2px;">${j.sub}</span></span></button>`).join('') + '</div>';
      stageEl.querySelectorAll('[data-job]').forEach((b) => b.addEventListener('click', () => { Object.assign(this.st, { job: b.dataset.job, shape: null, c: null, L: null }); this.render(); }));
    } else if (stage === 1) {
      const shapes = []; this.matches(s.job, null).forEach((p) => { const sh = (T[p.handle] || {}).s; if (sh && shapes.indexOf(sh) < 0) shapes.push(sh); });
      const order = ['straight', 'angle', 'fixed', 'curve', 'center', 'special'];
      const glyph = {
        straight: '<span style="position:absolute;left:0;right:14%;top:20px;height:6px;background:#2038E8;display:block;"></span>',
        angle: '<span style="position:absolute;left:6px;top:2px;bottom:4px;width:6px;background:#FF4B00;display:block;"></span><span style="position:absolute;left:6px;bottom:4px;width:64%;height:6px;background:#FF4B00;display:block;"></span>',
        fixed: '<span style="position:absolute;left:8px;bottom:2px;width:0;height:0;border-left:56px solid transparent;border-bottom:38px solid #6E30F2;display:block;"></span>',
        curve: '<span style="position:absolute;left:4px;top:6px;width:80px;height:64px;border-top:6px solid #FF3D9A;border-radius:50%;display:block;"></span>',
        center: '<span style="position:absolute;left:0;right:14%;top:20px;height:6px;background:#00C2FF;display:block;"></span><span style="position:absolute;left:calc(43% - 7px);top:13px;width:14px;height:14px;border:3px solid #131313;border-radius:50%;background:#FFD500;display:block;"></span>',
        special: '<span style="position:absolute;left:4px;top:16px;width:14px;height:14px;background:#FFC400;display:block;"></span><span style="position:absolute;left:26px;top:16px;width:14px;height:14px;background:#FF7A00;display:block;"></span><span style="position:absolute;left:48px;top:16px;width:14px;height:14px;background:#00C2FF;display:block;"></span>'
      };
      stageEl.innerHTML = '<div style="display:grid;grid-template-columns:repeat(auto-fit,minmax(min(240px,100%),1fr));gap:10px;">' + order.filter((x) => shapes.indexOf(x) > -1).map((sh) =>
        `<button class="lf2__shape" data-shape="${sh}"><span aria-hidden="true" style="display:block;height:44px;position:relative;margin-bottom:10px;">${glyph[sh]}</span><span style="font-weight:700;font-size:15px;">${this.SH[sh]}</span></button>`).join('') + '</div>';
      stageEl.querySelectorAll('[data-shape]').forEach((b) => b.addEventListener('click', () => { Object.assign(this.st, { shape: b.dataset.shape, c: null, L: null }); this.render(); }));
    } else if (stage === 2) {
      stageEl.innerHTML = '<div style="display:grid;grid-template-columns:repeat(auto-fit,minmax(min(240px,100%),1fr));gap:10px;">' + cOpts.map((o) =>
        `<button class="lf2__copt" data-c="${o.v}"><span style="display:block;font-weight:700;font-size:15px;">${o.label}</span><span style="display:block;font-size:12.5px;opacity:.75;margin-top:3px;">${o.sub}</span></button>`).join('') + '</div>';
      stageEl.querySelectorAll('[data-c]').forEach((b) => b.addEventListener('click', () => { this.st.c = b.dataset.c; this.st.L = null; this.render(); }));
    } else if (allBlack) {
      stageEl.innerHTML = `<div style="background:#131313;color:#F2EFE4;border:3px solid #131313;box-shadow:8px 9px 0 #00E5A0;padding:26px;">
        <div style="font-family:'IBM Plex Mono',monospace;font-size:11px;letter-spacing:.2em;color:#00E5A0;">FAMILY 07 — BLACK ENGRAVED</div>
        <h2 style="font-family:'Bricolage Grotesque',sans-serif;font-weight:800;font-size:clamp(24px,3vw,36px);line-height:1.05;margin:10px 0 10px;">Your match depends on how you stand.</h2>
        <p style="margin:0 0 18px;font-size:15px;line-height:1.55;color:#C9C5B8;">These rules are engraved for a working edge and a reading direction. Two answers in the Orientation Lab resolve the exact one.</p>
        <div style="display:flex;flex-wrap:wrap;gap:10px;">
          <a class="lf2__lab-go" href="/pages/orientation-lab?from=finder">Continue in the Orientation Lab — your answers carry over</a>
          <a class="lf2__lab-go" style="background:transparent;color:#F2EFE4;border-color:#555;" href="${(this.byH['black-anodized-e-metric-ruler-inch-centimeter'] || {}).url || '#'}">Skip it — the inch + cm rule reads from either side (by request)</a>
        </div></div>`;
    } else {
      const best = finl[0];
      let alts = finl.slice(1, 3);
      if (alts.length < 2) this.matches(s.job, null).sort((a, b) => ((T[b.handle] || {}).rank || 0) - ((T[a.handle] || {}).rank || 0)).forEach((p) => { if (alts.length < 2 && p !== best && alts.indexOf(p) < 0) alts.push(p); });
      const bvs = best.variants;
      let bvi = bvs.findIndex((v) => v.available); if (bvi < 0) bvi = 0;
      if (s.c && s.c.slice(0, 1) === 's') { const tgt = {sm:14,md:48,lg:96}[s.c.slice(2)]; let bd = 1e9;
        bvs.forEach((v, i) => { const L = (v.mm || 0) / 25.4; if (L && Math.abs(L - tgt) < bd && v.available) { bd = Math.abs(L - tgt); bvi = i; } }); }
      if (s.L != null && bvs[s.L]) bvi = s.L;
      const bv = bvs[bvi] || {};
      const jobL = (this.JOBS.find((j) => j.id === s.job) || {}).label || '';
      const shapeL = this.SH[s.shape] || '';
      const because = [];
      if (jobL) because.push('Fits the job — ' + jobL.toLowerCase());
      if (shapeL) because.push('The form you chose — ' + shapeL.toLowerCase());
      if (s.c) { const kind = s.c.slice(0, 1);
        because.push(kind === 'u' ? 'Calibrated in the system you read' : (kind === 's' ? 'Sized to the span of your work' : (s.c === 'g:y' ? 'The cork backing grips the sheet' : 'Slides freely for fast marking'))); }
      const lensChips = bvs.length > 1 ? `<div style="font-family:'IBM Plex Mono',monospace;font-size:10px;letter-spacing:.16em;margin:0 0 7px;opacity:.85;">ADJUST THE LENGTH</div>
        <div style="display:flex;flex-wrap:wrap;gap:7px;margin:0 0 12px;">${bvs.map((v, i) =>
          `<button data-blen="${i}" style="background:${i === bvi ? '#131313' : 'rgba(251,248,239,.92)'};color:${i === bvi ? '#FBF8EF' : '#131313'};text-decoration:${v.available ? 'none' : 'line-through'};border:2px solid #131313;padding:8px 12px;font-family:'IBM Plex Mono',monospace;font-size:12px;cursor:pointer;">${v.title}</button>`).join('')}</div>` : '';
      stageEl.innerHTML = `<div style="background:#2038E8;color:#FFFFFF;border:3px solid #131313;box-shadow:8px 9px 0 #131313;padding:24px;display:grid;grid-template-columns:repeat(auto-fit,minmax(min(280px,100%),1fr));gap:22px;align-items:center;">
        <div style="background:#FFFFFF;border:3px solid #131313;padding:16px;"><img loading="lazy" decoding="async" src="${best.img}" width="300" height="300" alt="${best.name}" style="width:100%;height:240px;object-fit:contain;"></div>
        <div>
          <div style="font-family:'IBM Plex Mono',monospace;font-size:10.5px;letter-spacing:.18em;opacity:.8;">YOUR EXACT MATCH</div>
          <h2 style="font-family:'Bricolage Grotesque',sans-serif;font-weight:800;font-size:clamp(26px,3.2vw,40px);line-height:1;margin:8px 0 8px;">${best.name}</h2>
          <p style="margin:0 0 10px;font-size:15px;line-height:1.55;">${(T[best.handle] || {}).alt || ''}</p>
          <div style="background:rgba(251,248,239,.92);color:#131313;border:2px solid #131313;padding:11px 13px;margin:0 0 12px;display:flex;flex-direction:column;gap:4px;">
            <div style="font-family:'IBM Plex Mono',monospace;font-size:9.5px;letter-spacing:.16em;color:#6B675C;">WHY THIS WON</div>
            ${because.map((b) => `<div style="display:flex;gap:8px;align-items:baseline;font-size:13px;line-height:1.45;"><span aria-hidden="true" style="width:7px;height:7px;background:#131313;flex:none;"></span>${b}</div>`).join('')}
          </div>
          ${lensChips}
          <div style="font-family:'IBM Plex Mono',monospace;font-size:12px;letter-spacing:.06em;margin:0 0 4px;">${bv.title || ''}</div>
          <div style="font-family:'Bricolage Grotesque',sans-serif;font-weight:800;font-size:28px;margin:0 0 14px;">${bv.price || ''}</div>
          <div style="display:flex;flex-wrap:wrap;gap:10px;">
            <a class="lf2__btn-ink" style="text-decoration:none;display:inline-block;" href="${best.url}?variant=${bv.id}">View product</a>
            <button class="lf2__btn-ghost" data-badd="${bv.id}">Add to cart</button>
            <button data-brestart style="background:transparent;color:#FFFFFF;border:3px solid transparent;padding:13px 6px;font-family:'Archivo',sans-serif;font-weight:700;font-size:14px;cursor:pointer;text-decoration:underline;">Start over</button>
          </div>
        </div></div>
        <div style="margin-top:22px;">
          <div style="font-family:'IBM Plex Mono',monospace;font-size:11px;letter-spacing:.18em;color:#6B675C;margin:0 0 10px;">ALSO CONSIDER — WITH THE TRADEOFF STATED</div>
          <div style="display:grid;grid-template-columns:repeat(auto-fit,minmax(min(280px,100%),1fr));gap:12px;">
            ${alts.map((al) => `<a class="lf2__alt" href="${al.url}"><img loading="lazy" decoding="async" src="${al.img}" width="300" height="300" alt="" style="width:74px;height:56px;object-fit:contain;flex:none;"><span style="min-width:0;"><span style="display:block;font-weight:700;font-size:14.5px;">${al.name}</span><span style="display:block;font-size:13px;line-height:1.4;color:#4A473C;margin-top:2px;">${(T[al.handle] || {}).alt || ''}</span><span style="display:block;font-family:'IBM Plex Mono',monospace;font-size:12px;margin-top:4px;">${(al.variants[0] || {}).price || ''}</span></span></a>`).join('')}
          </div>
        </div>`;
      stageEl.querySelectorAll('[data-blen]').forEach((b) => b.addEventListener('click', () => { this.st.L = Number(b.dataset.blen); this.render(); }));
      const restart = stageEl.querySelector('[data-brestart]');
      if (restart) restart.addEventListener('click', () => { this.st = { job: null, shape: null, c: null, L: null }; this.render(); });
      const addBtn = stageEl.querySelector('[data-badd]');
      if (addBtn) addBtn.addEventListener('click', async () => {
        await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: Number(addBtn.dataset.badd), quantity: 1 }) });
        window.location.href = '/cart';
      });
    }
    // progress bar dims to active families
    const famOfH = (h) => h.indexOf('black-') === 0 ? 6 : (h.indexOf('t-square') > -1 ? 1 : (h.indexOf('l-square') > -1 ? 2 : (h.indexOf('curve') > -1 ? 3 : (h.indexOf('triangle') > -1 ? 4 : ((T[h] || {}).s === 'special' || (T[h] || {}).s === 'center' ? 5 : 0)))));
    const act = {}; liveSet.forEach((p) => { act[famOfH(p.handle)] = 1; });
    this.querySelectorAll('[data-f-prog] span').forEach((sp, i) => { sp.style.opacity = act[i] ? 1 : 0.14; });
  }
}
customElements.define('lance-finder', LanceFinder);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lance-header"]) return;
  try {
    
class LanceHeader extends HTMLElement {
  connectedCallback() {
    this.megas = this.querySelectorAll('[data-mega]');
    this.querySelectorAll('[data-mega-toggle]').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.stopPropagation();
        const panel = this.querySelector(`[data-mega="${btn.dataset.megaToggle}"]`);
        const open = panel.hidden;
        this.closeAll();
        panel.hidden = !open;
        btn.setAttribute('aria-expanded', String(open));
      });
    });
    const navBtn = this.querySelector('[data-nav-toggle]');
    const drawer = this.querySelector('[data-nav-drawer]');
    navBtn.addEventListener('click', () => {
      drawer.hidden = !drawer.hidden;
      navBtn.textContent = drawer.hidden ? 'Menu' : 'Close';
      navBtn.setAttribute('aria-expanded', String(!drawer.hidden));
    });
    document.addEventListener('click', (e) => { if (!this.contains(e.target)) this.closeAll(); });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') this.closeAll(); });
    const cartBtn = this.querySelector('[data-cart-open]');
    cartBtn.addEventListener('click', () => {
      const d = document.querySelector('cart-drawer');
      if (d && typeof d.open === 'function') d.open(); else window.location.href = window.routes.cart_url;
    });
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
        const cartUrl = (window.routes && window.routes.cart_url) || '/cart';
        fetch(`${cartUrl}.js`, {
          credentials: 'same-origin',
          headers: { Accept: 'application/json' }
        })
          .then((response) => response.ok ? response.json() : Promise.reject())
          .then((cart) => {
            this.querySelectorAll('[data-cart-count]').forEach((count) => {
              count.textContent = String(Number(cart.item_count) || 0);
            });
          })
          .catch(() => {});
      });
    }
  }
  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) this.cartUpdateUnsubscriber();
  }
  closeAll() {
    this.megas.forEach((m) => { m.hidden = true; });
    this.querySelectorAll('[data-mega-toggle]').forEach((b) => b.setAttribute('aria-expanded', 'false'));
  }
}
customElements.define('lance-header', LanceHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lance-lab"] && !Shopify.designMode) return;
  try {
    
class LanceLab extends HTMLElement {
  connectedCallback() {
    this.P = JSON.parse(this.querySelector('[data-lab-products]').textContent);
    this.st = { u: null, e: null, d: null, L: 0 };
    if (new URLSearchParams(location.search).get('from') === 'finder') {
      const banner = this.querySelector('[data-lab-from]');
      banner.hidden = false;
      this.querySelector('[data-lab-from-clear]').addEventListener('click', () => { banner.hidden = true; });
    }
    this.querySelectorAll('[data-lab-unit]').forEach((b) => b.addEventListener('click', () => {
      this.st.u = b.dataset.labUnit;
      if (this.st.u === 'both') { this.st.e = null; this.st.d = null; }
      this.st.L = 0; this.render();
    }));
    this.querySelectorAll('[data-lab-edge]').forEach((b) => b.addEventListener('click', () => { if (this.st.u === 'both') return; this.st.e = b.dataset.labEdge; this.st.L = 0; this.render(); }));
    this.querySelectorAll('[data-lab-dir]').forEach((b) => b.addEventListener('click', () => { if (this.st.u === 'both') return; this.st.d = b.dataset.labDir; this.st.L = 0; this.render(); }));
    this.querySelectorAll('[data-lab-edit]').forEach((b) => b.addEventListener('click', () => {
      const n = b.dataset.labEdit;
      if (n === '1') this.st.u = null; if (n === '2') this.st.e = null; if (n === '3') this.st.d = null;
      this.render();
    }));
    // expert matrix
    const mx = this.querySelector('[data-lab-matrix]');
    const combos = [];
    [['english','INCH'],['metric','CM']].forEach((u) => [['top','TOP'],['bottom','BOT']].forEach((e) => [['lr','L→R'],['rl','R→L']].forEach((d) => combos.push({ u: u[0], e: e[0], d: d[0], label: u[1] + ' · ' + e[1] + ' · ' + d[1] }))));
    combos.push({ u: 'both', e: null, d: null, label: 'INCH + CM · COMBINED' });
    mx.innerHTML = combos.map((c, i) => `<button class="llab__mx" data-mx="${i}">${c.label}</button>`).join('');
    mx.querySelectorAll('[data-mx]').forEach((b) => b.addEventListener('click', () => {
      const c = combos[Number(b.dataset.mx)];
      this.st = { u: c.u, e: c.e, d: c.d, L: 0 }; this.render();
    }));
    this.combos = combos;
    this.querySelector('[data-lab-flip]').addEventListener('click', () => { this.st.d = this.st.d === 'lr' ? 'rl' : 'lr'; this.render(); });
    this.querySelector('[data-lab-reset]').addEventListener('click', () => { this.st = { u: null, e: null, d: null, L: 0 }; this.render(); });
    this.render();
  }
  handle() {
    const s = this.st;
    if (s.u === 'both') return 'black-anodized-e-metric-ruler-inch-centimeter';
    if (!s.u || !s.e || !s.d) return null;
    const prefix = s.u === 'metric' ? 'black-metric' : 'black-anodized';
    return `${prefix}-${s.d === 'lr' ? 'left-right' : 'right-left'}-${s.e}-edge-rule`;
  }
  render() {
    const s = this.st, q = (x) => this.querySelector(x);
    const both = s.u === 'both';
    const effU = s.u || 'english', effE = s.e || 'top', effD = s.d || 'lr';
    const done = !!s.u && (both || (!!s.e && !!s.d));
    this.querySelectorAll('[data-lab-unit]').forEach((b) => b.classList.toggle('is-sel', b.dataset.labUnit === s.u));
    // bench
    const nums = effU === 'metric' ? ['0','5','10','15','20','25','30'] : ['0','2','4','6','8','10','12'];
    const seq = effD === 'rl' ? nums.slice().reverse() : nums;
    q('[data-lab-topnums]').innerHTML = seq.map((n) => `<span>${n}</span>`).join('');
    q('[data-lab-botnums]').innerHTML = seq.map((n) => `<span>${n}</span>`).join('');
    q('[data-lab-topnums]').style.opacity = both || effE === 'top' ? 1 : 0.25;
    q('[data-lab-botnums]').style.opacity = both || effE === 'bottom' ? 1 : 0.25;
    q('[data-lab-topbar]').style.background = s.e === 'top' || both ? '#00E5FF' : '#3A3A3A';
    q('[data-lab-botbar]').style.background = s.e === 'bottom' ? '#FFB300' : '#3A3A3A';
    q('[data-lab-zero]').style.left = both ? '45%' : (effD === 'lr' ? '4%' : 'calc(96% - 18px)');
    const at = q('[data-lab-arrowtxt]');
    if (both) { at.textContent = '⇄ READS FROM EITHER SIDE'; at.style.color = '#00E5A0'; }
    else if (s.d) { at.textContent = s.d === 'lr' ? '⟶ NUMBERS CLIMB LEFT TO RIGHT' : '⟵ NUMBERS CLIMB RIGHT TO LEFT'; at.style.color = s.d === 'lr' ? '#00805A' : '#C4147A'; }
    else { at.textContent = 'SET THE EDGE AND DIRECTION'; at.style.color = '#9A968A'; }
    q('[data-lab-orienttxt]').textContent = done ? (both ? 'INCH + CM · EITHER SIDE' : `${effU === 'metric' ? 'CM' : 'INCH'} · ${effE.toUpperCase()} EDGE · ${effD === 'lr' ? 'L→R' : 'R→L'}`) : '';
    // question cards
    const uLabels = { english: 'Inch — eighths and sixteenths', metric: 'Metric — centimeters and millimeters', both: 'Inch + cm — combined, reads from either side' };
    q('[data-lab-a1]').textContent = s.u ? uLabels[s.u] : 'Pick inch, cm, or the combined rule above.';
    q('[data-lab-a1]').style.color = s.u ? '#00804A' : '#6B675C';
    q('[data-lab-edit="1"]').hidden = !s.u;
    const q2 = q('[data-lab-q2]'), q3 = q('[data-lab-q3]');
    q2.style.opacity = s.u && !both ? 1 : 0.5;
    q2.style.borderColor = s.e ? '#131313' : (s.u && !both ? '#131313' : '#D9D4C2');
    q('[data-lab-a2]').textContent = both ? 'Not needed — reads from either side.' : (s.e ? (s.e === 'top' ? 'Top edge — the far edge, against the work.' : 'Bottom edge — the near edge, against the work.') : '—');
    q('[data-lab-a2]').style.color = s.e || both ? '#00804A' : '#6B675C';
    q('[data-lab-edit="2"]').hidden = !s.e;
    q('[data-lab-q2opts]').hidden = !(s.u && !both && !s.e);
    q3.style.opacity = s.e && !both ? 1 : 0.5;
    q3.style.borderColor = s.d ? '#131313' : (s.e && !both ? '#131313' : '#D9D4C2');
    q('[data-lab-a3]').textContent = both ? 'Not needed — reads from either side.' : (s.d ? (s.d === 'lr' ? 'Left to right — zero at your left hand.' : 'Right to left — zero at your right hand.') : '—');
    q('[data-lab-a3]').style.color = s.d || both ? '#00804A' : '#6B675C';
    q('[data-lab-edit="3"]').hidden = !s.d;
    q('[data-lab-q3opts]').hidden = !(s.u && !both && s.e && !s.d);
    q('[data-lab-bothnote]').hidden = !both;
    // matrix selection state
    this.querySelectorAll('[data-mx]').forEach((b, i) => {
      const c = this.combos[i];
      b.classList.toggle('is-sel', done && c.u === s.u && c.e === s.e && c.d === s.d);
    });
    // result
    const res = q('[data-lab-result]');
    const h = done ? this.handle() : null;
    const p = h ? this.P[h] : null;
    res.hidden = !p;
    if (!p) return;
    let vi = Math.min(this.st.L, p.variants.length - 1);
    const v = p.variants[vi] || {};
    q('[data-lab-resimg]').src = p.img; q('[data-lab-resimg]').alt = p.name;
    q('[data-lab-resname]').textContent = p.name;
    q('[data-lab-why]').textContent = both
      ? 'One rule, both systems, engraved to read correctly from either side of the bench — edge and direction never matter.'
      : `Standing at the bench edge, this rule reads ${effD === 'lr' ? 'left to right' : 'right to left'} along the ${effE} working edge — so the numbers are upright and climbing away from your zero, exactly as you look down at the work.`;
    const chips = [];
    const uColors = { english: '#00C2FF', metric: '#FFD500', both: '#00E5A0' };
    chips.push([both ? 'INCH + CM' : (effU === 'metric' ? 'METRIC (CM)' : 'INCH'), uColors[effU] || '#00E5A0']);
    if (!both) { chips.push([effE === 'top' ? 'TOP EDGE' : 'BOTTOM EDGE', effE === 'top' ? '#00E5FF' : '#FFB300']);
      chips.push([effD === 'lr' ? 'READS L → R' : 'READS R → L', effD === 'lr' ? '#00E5A0' : '#FF3D9A']); }
    chips.push(['FROM YOUR POSITION', '#F2EFE4']);
    q('[data-lab-chips]').innerHTML = chips.map((c) => `<span style="border:2px solid ${c[1]};color:${c[1]};font-family:'IBM Plex Mono',monospace;font-size:10.5px;letter-spacing:.1em;padding:4px 9px;">${c[0]}</span>`).join('');
    q('[data-lab-vcount]').textContent = p.variants.length + ' LENGTHS';
    const lensEl = q('[data-lab-lens]');
    lensEl.innerHTML = p.variants.map((vv, i) => `<button data-ll="${i}" style="background:${i === vi ? '#FFD500' : 'transparent'};color:${i === vi ? '#131313' : (vv.available ? '#F2EFE4' : '#77736A')};border:2px solid ${i === vi ? '#FFD500' : '#3A3A3A'};padding:8px 12px;font-family:'IBM Plex Mono',monospace;font-size:12px;cursor:pointer;">${vv.title}</button>`).join('');
    lensEl.querySelectorAll('[data-ll]').forEach((b) => b.addEventListener('click', () => { this.st.L = Number(b.dataset.ll); this.render(); }));
    q('[data-lab-sku]').textContent = v.sku || '';
    const av = q('[data-lab-avail]');
    av.textContent = v.available ? 'AVAILABLE' : 'CURRENTLY UNAVAILABLE';
    av.style.color = v.available ? '#00E5A0' : '#FF8A5C';
    q('[data-lab-price]').textContent = v.price || '';
    q('[data-lab-view]').href = `${p.url}?variant=${v.id}`;
    q('[data-lab-flip]').hidden = both;
    const add = q('[data-lab-add]');
    add.textContent = v.available ? `Add to cart — ${v.price}` : 'Request this configuration';
    add.onclick = async () => {
      if (!v.available) return;
      await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: v.id, quantity: 1 }) });
      window.location.href = '/cart';
    };
  }
}
customElements.define('lance-lab', LanceLab);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lance-norules-product"]) return;
  try {
    
class LanceNoRulesProduct extends HTMLElement {
  connectedCallback() {
    const variants = JSON.parse(this.querySelector('[data-nrp-variants]').textContent);
    const inquiry = this.querySelector('[data-nrp-inquiry]');
    this.querySelectorAll('[data-nrp-variant-id]').forEach((button) => button.addEventListener('click', () => {
      const variant = variants.find((item) => item.id === Number(button.dataset.nrpVariantId));
      if (!variant) return;
      this.querySelectorAll('[data-nrp-variant-id]').forEach((item) => {
        const active = item === button;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-checked', String(active));
      });
      this.querySelector('[data-nrp-price]').textContent = variant.price;
      this.querySelector('[data-nrp-variant]').textContent = variant.title;
      const sku = this.querySelector('[data-nrp-sku]');
      if (sku) sku.textContent = variant.sku || '';
      inquiry.dataset.inqCtx = `${document.querySelector('h1').textContent}||${variant.title} · ${variant.price}`;
      const url = new URL(location.href);
      url.searchParams.set('variant', variant.id);
      history.replaceState({}, '', url);
    }));
    this.querySelectorAll('[data-nrp-thumb]').forEach((button) => button.addEventListener('click', () => {
      const image = this.querySelector('[data-nrp-main-image]');
      image.src = button.dataset.nrpThumb;
      image.srcset = button.dataset.nrpThumbSrcset || '';
      this.querySelectorAll('[data-nrp-thumb]').forEach((item) => item.classList.toggle('is-active', item === button));
    }));
  }
}
customElements.define('lance-norules-product', LanceNoRulesProduct);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lance-partner"] && !Shopify.designMode) return;
  try {
    
class LancePartnerPage extends HTMLElement {
  connectedCallback() {
    this.querySelectorAll('[data-reorder]').forEach((b) => b.addEventListener('click', async () => {
      b.disabled = true; b.textContent = 'Adding…';
      const d = document.querySelector('cart-drawer');
      const formData = new FormData();
      formData.append('id', b.dataset.reorder);
      formData.append('quantity', b.dataset.qty);
      if (d && typeof d.getSectionsToRender === 'function') {
        formData.append('sections', d.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        d.setActiveElement(document.activeElement);
      }
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        body: formData
      });
      const parsedState = await response.json();
      if (!response.ok || parsedState.status) {
        b.textContent = 'Try again';
        b.disabled = false;
        return;
      }
      b.textContent = 'Added ✓'; setTimeout(() => { b.textContent = 'Reorder'; b.disabled = false; }, 1600);
      if (d && typeof d.renderContents === 'function') {
        d.renderContents(parsedState);
        d.classList.remove('is-empty');
      }
    }));
  }
}
customElements.define('lance-partner-page', LancePartnerPage);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lance-pdp"]) return;
  try {
    
class LancePdp extends HTMLElement {
  connectedCallback() {
    this.style.setProperty('--accent', this.dataset.accent);
    const variants = JSON.parse(this.querySelector('[data-variants]').textContent);
    const maxMM = Math.max(...variants.map((v) => v.mm || 0), 1);
    const q = (s) => this.querySelector(s);
    const setText = (s, t) => { const el = q(s); if (el) el.textContent = t; };
    const bar = q('[data-atc-bar]');
    const select = (id) => {
      const v = variants.find((x) => x.id === id);
      if (!v) return;
      this.querySelectorAll('[data-variant]').forEach((b) => {
        const sel = Number(b.dataset.variant) === id;
        b.classList.toggle('is-sel', sel);
        b.setAttribute('aria-checked', String(sel));
      });
      setText('[data-price]', v.price); setText('[data-price-btn]', v.price); setText('[data-price-bar]', v.price);
      setText('[data-varlabel]', v.title); setText('[data-varlabel-bar]', v.title); setText('[data-sku]', v.sku || '');
      const avail = q('[data-avail]');
      if (avail) { avail.textContent = v.available ? 'Available' : 'Currently unavailable'; avail.style.color = v.available ? '#00804A' : '#B33500'; }
      const idInput = q('[data-form-variant]'); if (idInput) idInput.value = v.id;
      const atc = q('[data-atc]');
      if (atc) {
        atc.disabled = !v.available;
        atc.setAttribute('aria-disabled', String(!v.available));
        const atcLabel = q('[data-atc-label]');
        if (atcLabel) atcLabel.innerHTML = v.available ? `Add to cart — <span data-price-btn>${v.price}</span>` : 'Unavailable — request this configuration';
      }
      if (bar) {
        bar.disabled = !v.available;
        bar.setAttribute('aria-disabled', String(!v.available));
        bar.textContent = v.available ? 'Add to cart' : 'Unavailable';
      }
      const sil = q('[data-sil]');
      if (sil && v.mm) { sil.style.width = Math.max(16, Math.round((v.mm / maxMM) * 100)) + '%'; setText('[data-sil-txt]', v.title.toUpperCase()); }
      try { const u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u); } catch (e) {}
    };
    this.querySelectorAll('[data-variant]').forEach((b) => b.addEventListener('click', () => select(Number(b.dataset.variant))));
    this.querySelectorAll('[data-thumb]').forEach((t) => t.addEventListener('click', () => {
      const mainImage = q('[data-main-image]');
      mainImage.srcset = t.dataset.thumbSrcset || '';
      mainImage.src = t.dataset.thumb;
      this.querySelectorAll('[data-thumb]').forEach((x) => x.classList.toggle('is-sel', x === t));
    }));
    if (bar) bar.addEventListener('click', () => {
      const submitButton = q('[data-atc]');
      if (!submitButton || submitButton.disabled || bar.disabled) return;
      submitButton.click();
    });
  }
}
customElements.define('lance-pdp', LancePdp);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lance-pref"] && !Shopify.designMode) return;
  try {
    
class LancePref extends HTMLElement {
  connectedCallback() {
    const KEY = 'lance-aud-pref';
    const off = this.querySelector('[data-pref-off]');
    const apply = (id) => {
      off.hidden = !!id;
      this.querySelectorAll('[data-pref-panel]').forEach((p) => { p.hidden = p.dataset.prefPanel !== id; });
    };
    this.querySelectorAll('[data-pref-pick]').forEach((b) => b.addEventListener('click', () => {
      try { localStorage.setItem(KEY, b.dataset.prefPick); } catch (e) {}
      apply(b.dataset.prefPick);
    }));
    this.querySelectorAll('[data-pref-clear]').forEach((b) => b.addEventListener('click', () => {
      try { localStorage.removeItem(KEY); } catch (e) {}
      apply(null);
    }));
    let saved = null;
    try { saved = localStorage.getItem(KEY); } catch (e) {}
    if (saved && this.querySelector(`[data-pref-panel="${saved}"]`)) apply(saved);
  }
}
customElements.define('lance-pref', LancePref);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lance-retail"] && !Shopify.designMode) return;
  try {
    
class LanceRetail extends HTMLElement {
  connectedCallback() {
    // DC program-builder logic, verbatim
    this.DEFS = {
      rbStore: [{id:'art',l:'Art & drafting supply'},{id:'fabric',l:'Fabric & sewing'},{id:'hardware',l:'Hardware & shop'},{id:'campus',l:'Campus & bookstore'},{id:'gift',l:'Gift & museum'}],
      rbSpace: [{id:'counter',l:'Counter or endcap',s:'UNDER 2 FT'},{id:'bay',l:'A fixture bay',s:'2–4 FT'},{id:'wall',l:'A full wall panel',s:'4 FT+'}],
      rbAud: [{id:'teachers',l:'Teachers & students'},{id:'artists',l:'Artists & designers'},{id:'engineers',l:'Engineers & drafters'},{id:'makers',l:'Makers & sewists'},{id:'mixed',l:'A general mix'}],
      rbTerm: [{id:'perm',l:'Permanent program'},{id:'season',l:'Seasonal test'}]
    };
    this.st = { rbStore: null, rbSpace: null, rbAud: null, rbTerm: null };
    this.render();
  }
  render() {
    Object.keys(this.DEFS).forEach((key) => {
      const wrap = this.querySelector(`[data-rb="${key}"]`);
      wrap.innerHTML = this.DEFS[key].map((o) =>
        `<button class="lr9__rbopt${this.st[key] === o.id ? ' is-sel' : ''}" data-pick="${key}:${o.id}">${o.l}${o.s ? `<span style="display:block;font-family:'IBM Plex Mono',monospace;font-weight:400;font-size:9px;letter-spacing:.1em;opacity:.7;margin-top:2px;">${o.s}</span>` : ''}</button>`).join('');
      wrap.querySelectorAll('[data-pick]').forEach((b) => b.addEventListener('click', () => {
        const [k, id] = b.dataset.pick.split(':'); this.st[k] = id; this.render();
      }));
    });
    const s = this.st;
    const res = this.querySelector('[data-rb-result]');
    const done = s.rbStore && s.rbSpace && s.rbAud && s.rbTerm;
    if (!done) {
      res.innerHTML = `<div style="border:3px dashed #B7B2A0;background:#F6F2E7;padding:18px 20px;font-family:'IBM Plex Mono',monospace;font-size:11px;letter-spacing:.1em;color:#8F8B7E;">ANSWER ALL FOUR — THE RECOMMENDED PROGRAM ASSEMBLES HERE.</div>`;
      return;
    }
    const capsuleNames = {teachers:'Teachers Rule — Back to School',artists:'Artists Rule — Studio Tools',engineers:'Engineers Rule — Graduation',makers:'Makers Rule — Cutting & Layout',mixed:'Designers Rule — Anniversary'};
    let prog, why, fixture, orderClass, accent;
    if (s.rbTerm === 'season' || s.rbSpace === 'counter') {
      prog = 'X RULE CAPSULE · ' + capsuleNames[s.rbAud]; accent = '#FF3D9A';
      why = 'A focused message in the space you have — one audience, one occasion, refreshed each season without touching core shelving.';
      fixture = 'Counter display or endcap header — capsule signage, 5–8 instruments'; orderClass = 'ENTRY — SMALLEST OPENING ORDER';
    } else if (s.rbSpace === 'wall') {
      prog = 'THE LANCE 25'; accent = '#FFD500';
      why = 'Your space earns the full destination: all 25 instruments in seven-family organization, the website’s Tool Wall translated to the floor.';
      fixture = 'Full wall panel — seven color-blocked bays, spectrum band, in-aisle Finder QR'; orderClass = 'FULL PROGRAM — PLANOGRAM + REPLENISHMENT LOGIC';
    } else {
      prog = 'LANCE 7'; accent = '#FFC400';
      why = 'One best-seller from each family — the whole selection logic in a fixture bay, and the cleanest way to prove the category before the full wall.';
      fixture = 'Fixture bay — seven hooks, seven color chips, header card'; orderClass = 'MID — ONE FACING PER FAMILY + BACKSTOCK';
    }
    const covMap = {teachers:['STRAIGHT EDGES','TRIANGLES','T-SQUARES'],artists:['CURVES','CENTER-FINDING','STRAIGHT EDGES'],engineers:['T-SQUARES','TRIANGLES','BLACK ENGRAVED'],makers:['CORK-BACKED','L-SQUARES','BLACK ENGRAVED'],mixed:['ALL SEVEN FAMILIES']};
    const lbl = (key, id) => (this.DEFS[key].find((x) => x.id === id) || {}).l || '';
    const sel = [lbl('rbStore', s.rbStore), lbl('rbSpace', s.rbSpace), lbl('rbAud', s.rbAud), lbl('rbTerm', s.rbTerm)].join(' · ');
    res.innerHTML = `<div style="border:3px solid #131313;background:#131313;color:#F2EFE4;box-shadow:8px 9px 0 ${accent};padding:24px;">
      <div style="font-family:'IBM Plex Mono',monospace;font-size:10px;letter-spacing:.16em;color:#9A968A;">YOUR STORE — ${sel}</div>
      <h3 style="font-family:'Bricolage Grotesque',sans-serif;font-weight:800;font-size:clamp(26px,3.4vw,44px);line-height:1;margin:10px 0 8px;color:${accent};">${prog}</h3>
      <p style="margin:0 0 14px;font-size:15px;line-height:1.6;max-width:64ch;color:#C9C5B8;">${why}</p>
      <div style="display:grid;grid-template-columns:repeat(auto-fit,minmax(min(240px,100%),1fr));gap:10px;margin:0 0 16px;">
        <div style="border:2px solid #3A3A3A;padding:11px 13px;"><div style="font-family:'IBM Plex Mono',monospace;font-size:9px;letter-spacing:.14em;color:#9A968A;">FIXTURE</div><div style="font-size:13.5px;line-height:1.45;margin-top:4px;">${fixture}</div></div>
        <div style="border:2px solid #3A3A3A;padding:11px 13px;"><div style="font-family:'IBM Plex Mono',monospace;font-size:9px;letter-spacing:.14em;color:#9A968A;">OPENING-ORDER CLASS</div><div style="font-size:13.5px;line-height:1.45;margin-top:4px;">${orderClass}</div></div>
        <div style="border:2px solid #3A3A3A;padding:11px 13px;"><div style="font-family:'IBM Plex Mono',monospace;font-size:9px;letter-spacing:.14em;color:#9A968A;">FAMILY EMPHASIS</div><div style="display:flex;flex-wrap:wrap;gap:5px;margin-top:6px;">${(covMap[s.rbAud] || []).map((t) => `<span style="background:${accent};color:#131313;font-family:'IBM Plex Mono',monospace;font-size:9px;letter-spacing:.08em;padding:3px 7px;">${t}</span>`).join('')}</div></div>
      </div>
      <div style="display:flex;flex-wrap:wrap;gap:10px;">
        <button data-lance-inquiry data-inq-title="Program proposal — ${prog}" data-inq-ctx="${sel}||${fixture}||${orderClass}" data-inq-note="The retail desk turns this into a formal proposal — opening-order economics, display credits and fixture options, modeled account by account." style="background:${accent};color:#131313;border:3px solid ${accent};padding:13px 22px;font-family:'Archivo',sans-serif;font-weight:700;font-size:15px;cursor:pointer;">Request this proposal</button>
        <button data-rb-reset style="background:transparent;color:#9A968A;border:3px solid transparent;padding:13px 6px;font-family:'Archivo',sans-serif;font-weight:700;font-size:14px;cursor:pointer;text-decoration:underline;">Start over</button>
      </div></div>`;
    res.querySelector('[data-rb-reset]').addEventListener('click', () => { this.st = { rbStore: null, rbSpace: null, rbAud: null, rbTerm: null }; this.render(); });
  }
}
customElements.define('lance-retail', LanceRetail);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lance-teachers"] && !Shopify.designMode) return;
  try {
    
class LanceTeachers extends HTMLElement {
  connectedCallback() {
    // subject tabs
    this.querySelectorAll('[data-subj]').forEach((b) => b.addEventListener('click', () => {
      this.querySelectorAll('[data-subj]').forEach((x) => x.classList.toggle('is-active', x === b));
      this.querySelectorAll('[data-subj-panel]').forEach((p) => { p.hidden = p.dataset.subjPanel !== b.dataset.subj; });
    }));
    // classroom sets — DC classroomSets() verbatim
    this.PD = JSON.parse(this.querySelector('[data-set-data]').textContent);
    this.SETS = [
      {key:'straightedge',name:'Classroom Straightedge Set',color:'#2038E8',ink:'#FFFFFF',
       desc:'One true edge per student, plus an instructor rule for the board. The baseline every drawing program starts from.',
       perStudent:[['straight-edge-aluminum-rule',1]],shared:[['heavy-duty-t-square',1]]},
      {key:'geometry',name:'Geometry & Drafting Set',color:'#6E30F2',ink:'#FFFFFF',
       desc:'The two triangles geometry is built on, a square to pull against, and a straight edge — per desk.',
       perStudent:[['template-triangle-ruler-30-60-90',1],['template-triangle-ruler-45-45-90',1],['standard-t-square',1]],shared:[['heavy-duty-drafting-stainless-steel-t-square',1]]},
      {key:'artroom',name:'Art Room Set',color:'#FF3D9A',ink:'#FFFFFF',
       desc:'Curves, centers, and edges for the room where marks matter more than millimeters.',
       perStudent:[['lance-french-curve',1],['center-finding-rule',1],['straight-edge-aluminum-rule',1]],shared:[['lance-agate-pica-ruler',2]]},
      {key:'fashion',name:'Fashion & Patternmaking Set',color:'#FF7A5C',ink:'#131313',
       desc:'Hip and French curves, a calibrated corner, and a cuff rule — the patternmaking bench, per student.',
       perStudent:[['lance-hip-curve',1],['lance-french-curve',1],['aluminum-l-square',1],['aluminum-cuff-rule',1]],shared:[]},
      {key:'demo',name:'Instructor Demonstration Set',color:'#131313',ink:'#F2EFE4',fixed:true,
       desc:'The tools that lead the room — sized and weighted for the demonstration table, not the desk.',
       perStudent:[],sharedList:[['heavy-duty-t-square',1],['aluminum-l-square',1],['straight-edge-aluminum-rule',1],['lance-hip-curve',1]]}
    ];
    this.setKey = 'geometry'; this.classSize = 24;
    this.renderSets();
  }
  money(v) { return '$' + (v % 1 ? v.toFixed(2) : v.toFixed(0)); }
  renderSets() {
    const cur = this.SETS.find((s) => s.key === this.setKey) || this.SETS[0];
    const tabs = this.querySelector('[data-set-tabs]');
    tabs.innerHTML = this.SETS.map((s) => `<button class="lt__settab" data-settab="${s.key}" style="${s.key === this.setKey ? `background:${s.color};color:${s.ink};` : ''}">${s.name}</button>`).join('');
    tabs.querySelectorAll('[data-settab]').forEach((b) => b.addEventListener('click', () => { this.setKey = b.dataset.settab; this.renderSets(); }));
    const N = this.classSize;
    const comps = []; let est = 0, units = 0;
    const push = (h, qty, per) => { const p = this.PD[h]; if (!p) return; est += p.price * qty; units += qty;
      comps.push({ name: p.name, img: p.img, ea: this.money(p.price), qty, per, url: p.url, warn: !p.available }); };
    (cur.perStudent || []).forEach((it) => push(it[0], it[1] * N, 'per student'));
    (cur.shared || []).forEach((it) => push(it[0], it[1], 'instructor'));
    (cur.sharedList || []).forEach((it) => push(it[0], it[1], 'demonstration'));
    const sizeLabel = cur.fixed ? 'One demonstration set' : `${N} students · ${units} tools`;
    const estTxt = this.money(Math.round(est));
    const sizeChips = cur.fixed ? '' : `<div style="font-family:'IBM Plex Mono',monospace;font-size:10.5px;letter-spacing:.16em;margin-bottom:9px;">CLASS SIZE</div>
      <div style="display:flex;flex-wrap:wrap;gap:8px;margin-bottom:16px;">${[12,18,24,30].map((z) =>
        `<button data-size="${z}" style="background:${z === N ? '#131313' : '#FBF8EF'};color:${z === N ? '#FBF8EF' : '#131313'};border:2px solid #131313;padding:9px 15px;font-family:'Archivo',sans-serif;font-weight:700;font-size:14px;cursor:pointer;">${z}</button>`).join('')}</div>`;
    const card = this.querySelector('[data-set-card]');
    card.style.background = cur.color; card.style.color = cur.ink;
    card.innerHTML = `<h3 style="font-family:'Bricolage Grotesque',sans-serif;font-weight:800;font-size:clamp(24px,3vw,34px);line-height:1;margin:0 0 8px;">${cur.name}</h3>
      <p style="margin:0 0 16px;font-size:14.5px;line-height:1.5;">${cur.desc}</p>${sizeChips}
      <div style="background:#131313;color:#F2EFE4;border:3px solid #131313;padding:16px;">
        <div style="display:flex;align-items:baseline;justify-content:space-between;gap:10px;">
          <span style="font-family:'IBM Plex Mono',monospace;font-size:10.5px;letter-spacing:.14em;color:#9A968A;">${sizeLabel.toUpperCase()}</span>
          <span style="font-family:'Bricolage Grotesque',sans-serif;font-weight:800;font-size:30px;">${estTxt}</span>
        </div>
        <div style="font-family:'IBM Plex Mono',monospace;font-size:9.5px;letter-spacing:.08em;color:#8F8B7E;margin-top:6px;line-height:1.5;">ESTIMATED FROM LISTED PRICES — NOT A LIVE QUOTE. THE PRO DESK RESOLVES EXACT CONFIGURATIONS &amp; VOLUME PRICING.</div>
        <div style="display:flex;flex-wrap:wrap;gap:8px;margin-top:14px;">
          <button data-lance-inquiry data-inq-title="Classroom quote" data-inq-ctx="${cur.name}||${sizeLabel}||Estimated ${estTxt}" data-inq-note="The PRO desk resolves exact configurations and a formal quote." style="background:${cur.color};color:${cur.ink};border:2px solid ${cur.color};padding:12px 16px;font-family:'Archivo',sans-serif;font-weight:700;font-size:14px;cursor:pointer;">Request group pricing</button>
        </div>
      </div>`;
    card.querySelectorAll('[data-size]').forEach((b) => b.addEventListener('click', () => { this.classSize = Number(b.dataset.size); this.renderSets(); }));
    this.querySelector('[data-set-components]').innerHTML = comps.map((c) => `
      <article style="display:flex;align-items:center;gap:14px;background:#FBF8EF;border:2px solid #131313;padding:11px 14px;">
        <img src="${c.img}" loading="lazy" decoding="async" alt="${c.name}" style="width:64px;height:48px;object-fit:contain;flex:none;background:#FFFFFF;border:1px solid #E2DDCB;">
        <div style="flex:1;min-width:0;">
          <div style="font-family:'Archivo',sans-serif;font-weight:700;font-size:14.5px;line-height:1.2;"><a href="${c.url}" style="color:#131313;text-decoration:none;">${c.name}</a></div>
          <div style="font-family:'IBM Plex Mono',monospace;font-size:10.5px;letter-spacing:.06em;color:#6B675C;margin-top:3px;">${c.ea} EACH · ${c.per.toUpperCase()}</div>
          ${c.warn ? '<div style="display:inline-block;background:#B33500;color:#FBF8EF;font-family:\'IBM Plex Mono\',monospace;font-size:9px;letter-spacing:.1em;padding:3px 7px;margin-top:5px;">UNAVAILABLE — SUBSTITUTED AT QUOTE</div>' : ''}
        </div>
        <div style="font-family:'Bricolage Grotesque',sans-serif;font-weight:800;font-size:20px;flex:none;">×${c.qty}</div>
      </article>`).join('');
  }
}
customElements.define('lance-teachers', LanceTeachers);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lance-wall"]) return;
  try {
    
class LanceWall extends HTMLElement {
  connectedCallback() {
    const wall = this.querySelector('[data-wall-view]');
    const cmp = this.querySelector('[data-compare-view]');
    this.querySelectorAll('[data-mode]').forEach((b) => b.addEventListener('click', () => {
      const isWall = b.dataset.mode === 'wall';
      wall.hidden = !isWall; cmp.hidden = isWall;
      this.querySelectorAll('[data-mode]').forEach((x) => x.classList.toggle('is-active', x === b));
    }));
    this.querySelectorAll('[data-unit-filter]').forEach((b) => b.addEventListener('click', () => {
      const u = b.dataset.unitFilter;
      this.querySelectorAll('[data-unit-filter]').forEach((x) => x.classList.toggle('is-active', x === b));
      this.querySelectorAll('[data-unit]').forEach((el) => el.classList.toggle('is-dim', u !== 'all' && el.dataset.unit !== u));
    }));
    this.querySelectorAll('[data-fam-jump]').forEach((b) => b.addEventListener('click', () => {
      const el = document.getElementById('zone-' + b.dataset.famJump);
      if (el) window.scrollTo({ top: el.offsetTop - 128, behavior: 'smooth' });
    }));
    const keys = ['straight-edge-rulers','t-squares','l-squares','curves','triangles','specialty-rulers','black-anodized-rulers'];
    window.addEventListener('scroll', () => {
      let cur = keys[0];
      keys.forEach((k) => { const el = document.getElementById('zone-' + k); if (el && el.getBoundingClientRect().top < 210) cur = k; });
      this.querySelectorAll('[data-fam-jump]').forEach((b) => b.classList.toggle('is-active', b.dataset.famJump === cur));
    }, { passive: true });
  }
}
customElements.define('lance-wall', LanceWall);

  } catch(e) { console.error(e); }
})();
})();
